import png from './images/raiders.png'

export const colors = {
  dominant: '#C3D941',
  highlight: '#fcb53e',
}
export const fullname = 'Raiders'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/raiders.js